import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './LegalSidebar.scss';
import { Spin } from 'antd';

const LegalSidebar = memo(({ policiesList, isLoading, activeScreen, setActiveScreen }) => {
  return (
    <div className='legalsidebar'>
      <Spin spinning={isLoading}>
        <ul className='legalsidebar__list'>
          <li className='legalsidebar__list__item fz-12 text-taupe-80 no-link'>LEGAL</li>
          {policiesList?.length ? (
            policiesList.map((policy, index) => (
              <li
                className={`legalsidebar__list__item ${policy === activeScreen ? 'legalsidebar__list__item--active' : ''}`}
                key={index}
                onClick={() => setActiveScreen(policy)}
              >
                {policy}
              </li>
            ))
          ) : (
            <>{!isLoading && <li className='legalsidebar__list__item fz-12 text-taupe-80'>No Data Available</li>}</>
          )}
        </ul>
      </Spin>
    </div>
  );
});

LegalSidebar.propTypes = {
  policiesList: PropTypes.array,
  isLoading: PropTypes.bool,
  activeScreen: PropTypes.string,
  setActiveScreen: PropTypes.func,
};

LegalSidebar.defaultProps = {
  policiesList: [],
  isLoading: false,
  activeScreen: '',
  setActiveScreen: () => {},
};

export default LegalSidebar;
